import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Box,
  Button,
  Text,
} from '@razorpay/blade/components';

interface SuccessModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  employeeName: string;
}

export const SuccessModal: React.FC<SuccessModalProps> = ({ isOpen, onDismiss, employeeName }) => {
  return (
    <Modal
      isOpen={isOpen}
      onDismiss={onDismiss}
      size="small"
      accessibilityLabel="Employee Added Successfully">
      <ModalHeader title="Employee Added Successfully!" />

      <ModalBody>
        <Text size="medium">
          {employeeName} has been added to your organization. They will need to complete their
          profile by adding details like bank information and personal details. You can update
          their profile manually as well.
        </Text>
      </ModalBody>

      <ModalFooter>
        <Box display="flex" justifyContent="flex-end" width="100%">
          <Button variant="primary" onClick={onDismiss}>
            Continue
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
}; 